// @flow
import {
  CheckCircle,
  EnvelopeSimple,
  Gear,
  PaperPlaneTilt,
} from '@phosphor-icons/react'
import * as React from 'react'
import { useHistory, useParams } from 'react-router-dom'

import cn from '@/utils/tailwind/cn'

type Props = {
  negativeMargin?: boolean,
  resourceType?: 'form' | 'document' | 'packet',
}

function BuilderSideMenuSettings({
  negativeMargin = true,
  resourceType,
}: Props): React.Node {
  const history = useHistory()
  const params = useParams()

  const menuItems = React.useMemo(() => {
    const items = [
      {
        description: 'Setup your general settings for this form',
        icon: <Gear className="text-2xl text-gray-800" />,
        path: 'settings/general',
        title: 'General',
      },
      {
        description: `Receive an email when someone fills out your ${
          resourceType === 'document' ? 'pdf' : 'form'
        }`,
        icon: <EnvelopeSimple className="text-2xl text-gray-800" />,
        path: 'settings/notifications',
        title: 'Notifications',
      },
      {
        description: 'Customize the invitation message for this form',
        icon: <PaperPlaneTilt className="text-2xl text-gray-800" />,
        path: 'settings/custom-email-and-sms-invitation',
        title: 'Custom Email and SMS Invitation',
      },
      {
        description: 'Choose an ending after completion',
        icon: <CheckCircle className="text-2xl text-gray-800" />,
        path: 'settings/complete-page',
        title: 'Complete Page',
      },
    ]
    if (resourceType === 'packet') {
      const generalSettings = items?.find((item) => item.title === 'General')
      items.splice(items.indexOf(generalSettings), 1)
    }

    return items
  }, [resourceType])

  const baseUrl = React.useMemo(() => {
    switch (resourceType) {
      case 'document':
        return `/pdf/${params.resourceId}/edit`
      case 'packet':
        return `/packets/${params.packetId}`
      case 'form':
      default:
        return `/forms/${params.resourceId}`
    }
  }, [params.packetId, params.resourceId, resourceType])

  const navigateTo = (path: string) => {
    const url = [baseUrl, path].join('/')
    history.push(url)
  }

  return (
    <div style={negativeMargin ? { margin: -24 } : {}}>
      {/* This is cheating 👆  */}
      {menuItems.map((item) => {
        const isActive = history.location.pathname.includes(item.path)
        return (
          <button
            className={cn(
              'flex h-[fit-content] w-full cursor-pointer select-none items-start justify-start gap-2 border-l-4 border-l-transparent px-3 py-6 !outline-none hover:bg-[#eff6ff]',
              {
                'border-l-primary bg-[#eff6ff] [&>svg]:text-primary': isActive,
              }
            )}
            key={item.title}
            onClick={() => navigateTo(item.path)}
          >
            {item.icon}
            <div className="flex flex-col items-start justify-start">
              <span
                className={cn(
                  'text-base font-bold text-gray-700',
                  isActive && 'text-primary'
                )}
              >
                {item.title}
              </span>
              <span className="text-left text-sm text-gray-500">
                {item.description}
              </span>
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default BuilderSideMenuSettings
